import { httpPost } from "../services/http";


const state = document.querySelector('#cart') ? JSON.parse(localStorage.getItem('cart') || "[]") : [];
const defaultState = state;


export const cart = (state = defaultState, action) => {
	switch (action.type) {
		case 'CART':
			return [...action.data];
		default:
			return state;
	}
};

export const addToCart = (data) => {
	return (dispatch, state) => {
		httpPost('session/cart', [...state().cart, data])
			.then((data) => {
				localStorage.setItem('cart', JSON.stringify(data))
				dispatch({
					type: 'CART',
					data: data || []
				})
			})
	}
};

export const removeFromCart = (data) => {
	return (dispatch, state) => {
		httpPost('session/cart', [...state().cart.filter(el => el.id !== data.id)]).then(data => {
			localStorage.setItem('cart', JSON.stringify(data))
			dispatch({
				type: 'CART',
				data
			})
		})
	}
};

export const clearCart = () => {
	return (dispatch) => {
		httpPost('session/cart', [])
			.then((data) => {
				localStorage.setItem('cart', JSON.stringify(data))
				dispatch({
					type: 'CART',
					data
				})
			})
	}
};

export const changeCount = (data) => {
	return (dispatch, state) => {
		const newCart = state().cart.map((el) => {
			if (el.id === data.id) {
				return {
					...el,
					...data
				}
			}
			return el
		})

		httpPost('session/cart', newCart)
			.then((data) => {
				localStorage.setItem('cart', JSON.stringify(data))
				dispatch({
					type: 'CART',
					data
				})
			})
	}
};